var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMediumBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 171,
    height: 186,
    viewBox: "0 0 171 186",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-2{fill:none;stroke:#4b4b4b;stroke-miterlimit:10;stroke-width:3px}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Medium_building",
    transform: "translate(-1025 -329)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_809",
    fill: "none",
    d: "M0 0H171V186H0z",
    transform: "translate(1025 329)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_471",
    transform: "translate(1077.852 387.382)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_766",
    width: 72,
    height: 122,
    className: "cls-2",
    rx: 11.299,
    transform: "translate(.148 -.382)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_767",
    width: 19.745,
    height: 19.745,
    className: "cls-2",
    rx: 2.382,
    transform: "translate(25.563 102.252)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_768",
    width: 19.745,
    height: 19.745,
    className: "cls-2",
    rx: 2.382,
    transform: "translate(11.224 40.901)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_769",
    width: 19.745,
    height: 19.745,
    className: "cls-2",
    rx: 2.382,
    transform: "translate(40.137 40.901)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_770",
    width: 19.745,
    height: 19.745,
    className: "cls-2",
    rx: 2.382,
    transform: "translate(11.224 68.403)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_771",
    width: 19.745,
    height: 19.745,
    className: "cls-2",
    rx: 2.382,
    transform: "translate(40.137 68.403)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_772",
    width: 19.745,
    height: 19.745,
    className: "cls-2",
    rx: 2.382,
    transform: "translate(11.224 13.399)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_773",
    width: 19.745,
    height: 19.745,
    className: "cls-2",
    rx: 2.382,
    transform: "translate(40.137 13.399)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediumBuilding);
export default __webpack_public_path__ + "static/media/medium-building.23a462c3a8f9ed9acd5eb934bb4a0c68.svg";
export { ForwardRef as ReactComponent };